{
  "conversations": {
    "conversationsApp": "Aplicación de conversaciones",
    "locationId": "ID de la ubicación",
    "idToken": "Token de ID",
    "conversationRoutes": "Rutas de Conversación",
    "conversationProviders": "Proveedores de conversaciones",
    "viewTheListOfConversation": "Ver la Lista de conversaciones personalizada de proveedores añadidos a la Cuenta aquí.",
    "logo": "Logotipo",
    "name": "Nombre",
    "alias": "Alias",
    "type": "Tipo"
  }
}
